import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { EeaArticleDto } from 'src/api/v2';

const columnHelper = createColumnHelper<EeaArticleDto>();
const summaryColumnHelper = createColumnHelper<EeaArticleDto>();

export const eeaArticleColumns = [
  columnHelper.accessor((row) => row.name, {
    id: 'Artikkelnavn',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.article, {
    id: 'Artikkelkode',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];

export const eeaArticleSummaryColumns = [
  summaryColumnHelper.accessor((row) => row.name, {
    id: 'Artikkelnavn',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  summaryColumnHelper.accessor((row) => row.article, {
    id: 'Artikkelkode',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];
